// Organization Types

export type OrganizationType = 'brand' | 'agency';

export type OrganizationMemberRole = 'owner' | 'admin' | 'member' | 'viewer';

export type SystemRole = 'creator' | 'admin' | 'org';

export type OrganizationStatus = 'active' | 'deactivated';

export interface Organization {
  id: string;
  name: string;
  slug: string;
  type: OrganizationType;
  status: OrganizationStatus;
  icon_url: string | null;
  homepage: string | null;
  settings: Record<string, unknown>;
  created_at: string;
}

export interface OrganizationMembership {
  id: string;
  organization_id: string;
  profile_id: string;
  role: OrganizationMemberRole;
  invited_by: string | null;
  invited_at: string;
  accepted_at: string | null;
  organization: Organization;
}

export interface OrganizationMember {
  id: string;
  profile_id: string;
  role: OrganizationMemberRole;
  invited_at: string;
  accepted_at: string | null;
  profile_picture_url: string | null;
  profile: {
    id: string;
    username: string | null;
    email: string | null;
  };
}

export interface UserContext {
  profileId: string;
  email: string | null;
  username: string | null;
  updatedUsername: boolean;
  systemRole: SystemRole;
  organizations: OrganizationMembership[];
  isSystemAdmin: boolean;
  isOrgUser: boolean;
}

export interface OrganizationClient {
  id: string;
  name: string;
  slug: string;
  icon_url: string | null;
  homepage: string;
  organization_id: string;
  token: string | null;
  status?: 'active' | 'archived';
  created_at: string;
}

// Permission helpers
export const ROLE_HIERARCHY: OrganizationMemberRole[] = ['viewer', 'member', 'admin', 'owner'];

export function hasMinimumRole(
  userRole: OrganizationMemberRole,
  requiredRole: OrganizationMemberRole
): boolean {
  return ROLE_HIERARCHY.indexOf(userRole) >= ROLE_HIERARCHY.indexOf(requiredRole);
}

export function canManageOrg(role: OrganizationMemberRole): boolean {
  return hasMinimumRole(role, 'admin');
}

export function canEditContent(role: OrganizationMemberRole): boolean {
  return hasMinimumRole(role, 'member');
}

export function canViewContent(role: OrganizationMemberRole): boolean {
  return hasMinimumRole(role, 'viewer');
}









